import { createContext } from 'react';
import type { AudioRecords } from './types';

export const AudioRecordsContext = createContext<AudioRecords>(
  {} as AudioRecords,
);
AudioRecordsContext.displayName = 'AudioRecords';
